const isOverflownHorizontal = (element: Element) => {
	return element.clientWidth < element.scrollWidth;
};

const isOverflownVertical = (element: Element) => {
	return element.clientHeight < element.scrollHeight;
};

/**
 * Check if an element is overflown
 * @param element The element to check
 * @param direction The direction(s) to check
 * @returns `true` if the element is overflown
 *
 * @example
 * ```ts
 * isElementOverflown(document.body, 'vertical');
 * ```
 */
export const isElementOverflown = (
	element?: Element | null,
	direction: 'vertical' | 'horizontal' | 'both' | 'either' = 'vertical',
) => {
	if (!element) return false;

	return direction === 'horizontal'
		? isOverflownHorizontal(element)
		: direction === 'vertical'
		? isOverflownVertical(element)
		: direction === 'either'
		? isOverflownHorizontal(element) || isOverflownVertical(element)
		: isOverflownHorizontal(element) && isOverflownVertical(element);
};
